module.exports = true;



/*****************
 ** WEBPACK FOOTER
 ** ../~/core-js/library/modules/_library.js
 ** module id = 704
 ** module chunks = 3
 **/